export * from './lib/lazy-style.model';
export * from './lib/lazy-styles.directive';
export * from './lib/lazy-styles.service';
